import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import api from "../common/api";
import {
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row
} from "shards-react";
import {
  CircularProgress,
  Fab,
  MuiThemeProvider,
  createMuiTheme
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import EditIcon from "@material-ui/icons/Edit";
import CustomToolbar from "../common/AddButton";
import AddIcon from "@material-ui/icons/Add";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px 8px 0px 8px",
          fontSize: "0.73rem"
        }
      }
    }
  });

const Tasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toogleDropdownNew, setToogleDropdownNew] = useState(false);
  const [isProductive, setIsProductive] = useState(
    window.location.pathname === "/tasks" ? 1 : 0
  );
  const getTasks = async isProductive => {
    const token = localStorage.getItem("userToken");
    try {
      const response = await axios.get(api.tasksAdmin().index(isProductive), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTasks(response.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getTasks(isProductive);
  }, []);

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: "name",
      label: "Nombre",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "description",
      label: "Descripcion",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "task_sub_group",
      label: "Subgrupo",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "task_group",
      label: "Grupo",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "hansa_code",
      label: "Código",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "sap_active",
      label: "Activo SAP",
      options: {
        filter: true,
        filterType: "dropdown",
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? "Si" : "No";
        },
        sort: true
      }
    },
    {
      name: "sap_code",
      label: "Código SAP",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },
    {
      name: "sap_dimension",
      label: "Dimension SAP",
      options: {
        filter: true,
        filterType: "textField",
        sort: true
      }
    },

    {
      name: "Acciones",
      label: "",
      options: {
        filter: false,
        setCellHeaderProps: () => ({ align: "center" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowId = tableMeta.rowData[0];
          //const rowId = 1
          return (
            <div className="row" style={{ display: "block" }}>
              <Fab
                color="primary"
                aria-label="view"
                variant="extended"
                style={{ boxShadow: "none", backgroundColor: "green" }}
                fontSize="small"
                className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                href={"tasks/" + rowId + "/" + isProductive}
              >
                <EditIcon fontSize="small" />
              </Fab>
            </div>
          );
        }
      }
    }
  ];

  const options = {
    print: false,
    responsive: "stacked",
    selectableRowsOnClick: false,
    selectableRows: false,
    download: false,
    rowsPerPage: 10,
    customToolbar: () => {
      //return <CustomToolbar url={`0/${isProductive}`} />;
      return (
        <Dropdown
          className="d-inline"
          open={toogleDropdownNew}
          toggle={() => setToogleDropdownNew(!toogleDropdownNew)}
          style={{ backgroundColor: "none", margin: 0, padding: 0 }}
        >
          <DropdownToggle
            className="btn btn-secondary"
            style={{ backgroundColor: "none", margin: 0, padding: 0 }}
          >
            <AddIcon
              style={{ backgroundColor: "none", margin: 0, padding: 0 }}
            />
          </DropdownToggle>
          <DropdownMenu small right>
            <DropdownItem
              onClick={() => {
                window.location.href = "/tasks/0/" + isProductive;
              }}
            >
              Tarea
            </DropdownItem>
            <DropdownItem>Subgrupo</DropdownItem>
            <DropdownItem>Grupo</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      );
    },

    textLabels: {
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
        downloadCsv: "Exportar XLS"
      },
      body: {
        noMatch: !loading ? "No hay resultados" : <CircularProgress />
      },
      selectedRows: {
        text: "fila(s) seleccionadas"
      },
      viewColumns: {
        title: "Ver columnas"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de"
      },
      filter: {
        all: "Todos",
        title: "Filtros",
        reset: "Limpiar"
      }
    }
  };

  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <div>
            <MuiThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={`Lista de Articulos ${
                  isProductive ? "Productivos" : "No Productivos"
                }`}
                isLoading={loading}
                data={Object.values(tasks)}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Tasks;
